var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2426_10290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 20.9995C42 9.40157 32.5979 -0.000461578 21 -0.000461578C9.40203 -0.000461578 0 9.40157 0 20.9995C0 30.8481 6.78005 39.1118 15.9269 41.3811V27.4168H11.5965V20.9995H15.9269V18.2343C15.9269 11.0866 19.1616 7.77365 26.1789 7.77365C27.5093 7.77365 29.8049 8.03447 30.7441 8.29537V14.1127C30.2484 14.0605 29.3875 14.0344 28.318 14.0344C24.8746 14.0344 23.5441 15.3388 23.5441 18.73V20.9995H30.4034L29.2251 27.4168H23.5441V41.8457C33.9421 40.5898 42 31.7362 42 20.9995Z",
    fill: "#0866FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2257 27.4173L30.4042 21H23.5448V18.7304C23.5448 15.3392 24.8752 14.0349 28.3186 14.0349C29.3882 14.0349 30.249 14.0609 30.7447 14.1131V8.29586C29.8056 8.03496 27.5099 7.77406 26.1796 7.77406C19.1623 7.77406 15.9275 11.0871 15.9275 18.2348V21H11.5972V27.4173H15.9275V41.3816C17.5523 41.7846 19.2512 42 21.0006 42C21.862 42 22.7107 41.9469 23.5448 41.8462V27.4173H29.2257Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2426_10290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb1);
export default __webpack_public_path__ + "static/media/FB1.4545ebd0d30c93bfb5590f83b39bb314.svg";
export { ForwardRef as ReactComponent };